import { availabilityApi, isRezidorHotel } from '@/infrastructure/Configuration'
import { formatOccupancy, getQueryParams, filterOccupancies } from '@/infrastructure/Utils'
import ExternalStorage from '@/services/ExternalStorage'

export const RateCategoryTypes = {
  STANDARD: 'standard',
  LOYALTY: 'loyalty',
  PACKAGE: 'package'
}

export default class AvailabilityService {
  constructor(httpClient, hotelStayDatesFactory, dateFactory) {
    this.httpClient = httpClient
    this.hotelStayDatesFactory = hotelStayDatesFactory
    this.dateFactory = dateFactory
  }

  getPreviousAvailabilityRequest() {
    const queryParams = getQueryParams(window.location._search || window.location.search)

    const { adults, children, searchType, promotionCode, hotelCode, voucher } = queryParams

    const { checkInDate, checkOutDate } = this.hotelStayDatesFactory.create(queryParams)
    const occupancies = adults && children ? filterOccupancies(adults, children) : null

    return {
      checkInDate,
      checkOutDate,
      hotelCode,
      occupancies,
      searchType,
      promotionCode,
      voucher,
      rezidorProperty: isRezidorHotel
    }
  }

  async getRatesBySearchType(availabilityRequest) {
    const request = {
      ...availabilityRequest,
      checkInDate: this.dateFactory.formatDate(availabilityRequest.checkInDate),
      checkOutDate: this.dateFactory.formatDate(availabilityRequest.checkOutDate),
      ...formatOccupancy(availabilityRequest.occupancies)
    }
    delete request.occupancies

    const transactionId = ExternalStorage.session.transactionId()
    const saverHeader = (localStorage.getItem('saver') || 'true') === 'true'

    const config = {
      headers: {
        Saver: saverHeader,
        transactionId
      }
    }

    !transactionId && delete config.headers.transactionId
    !saverHeader && delete config.headers.Saver

    const response = await this.httpClient.post(availabilityApi + '/rates', request, config)

    return response?.data
  }
}
